<i18n lang='yml' src='../i18n/Listing.yml'></i18n>
<template>
  <div class="layout-tile">
    <div class="heading-block d-flex">
      <h4>
        <span class="program-name">{{ $t('logbook_list') }}</span>
      </h4>
      <a v-if="allow_logbook_creation == 'true' && show_add_new_logbook =='true'" class='btn btn-sm btn-success ml-auto' :href="new_logbook_path">
        <font-awesome-icon :icon="['fa', 'plus']"/>
        {{ $t('new_logbook') }}
      </a>
    </div>
    <filter-bar :filter_params = filter_params :filter_path = filter_path></filter-bar>
    <div class="alert alert-danger" role="alert" v-if="error">
      {{$t('loading_error') }}
    </div>
    <div v-else-if="logbooksList.length == 0">
      <div class="alert alert-warning" role="alert">
        {{noDataError}}
      </div>
    </div>
    
    <div class="content-block content-block-logbook" v-else-if="logbooksList.length > 0" :key="logbook.id" v-for="logbook in logbooksList">
      <div class="post-view">
        <div class="post-content">
          <div class="view-area d-flex">       
            <h5 class="heading-content mb-0">
              <!-- The name should only be visible to those who can approve (sponsors in a container) and will have STO ID in future-->
              <a v-if="allow_approval == 'true'" :href="setPath(logbook)" class="apprentice-name">
                {{logbook.user_identity.last_name}}, {{logbook.user_identity.first_name}} 
                <span v-if="logbook.user_identity.external_identifiers">
                  ({{logbook.user_identity.external_identifiers.sto_id}})
                </span>
              </a>
              <a :href="setPath(logbook)" class="logbook-name">{{logbook.name}}</a>
            </h5>    
          </div>
        </div>
      </div>
      <hr class="m-0"/>
      <div class="heading-block post-meta">
        <ul class="list-inline list-annotation align-items-start">
          <li class="progress-component" v-if="logbook.program_standard.skills_tracking">
            <progress-bar 
              :percentage_value="logbook.get_progress.percent" 
              :approved="logbook.get_progress.completed_count"
              :total="logbook.get_progress.mandatory_count"
              progress_message='progress-message-skills'
              type="success"
            >
            </progress-bar>
          </li>   
          <li class="progress-component" v-if="logbook.program_standard.hours_tracking">
            <progress-bar 
              :percentage_value="logbook.get_hour_progress.percent"
              :approved="logbook.get_hour_progress.completed_hours"
              :total="logbook.get_hour_progress.required_hours"
              progress_message='progress-message-hours'
              type="custom"
            >
            </progress-bar>
          </li>   
          

        </ul>
      </div>
      <div class="post-meta">
        <ul class="list-inline list-annotation">
          <li>{{ $t('logbook_status') }}
            <span class="status-badge">
              {{ $t(logbook.status) }}
            </span>
          </li>
          <li v-if="logbook.training_standard && logbook.training_standard.version" class="list-inline-item">{{ $t('training_standard') }} {{ logbook.training_standard.version }}</li>
          <li class="list-inline-item">{{ $t('created_at') }} {{ formatDate(logbook.created_at) }}</li>
          <li class="list-inline-item">{{ $t('last_updated') }} {{ formatDate(logbook.get_last_update) }}</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <h3>{{ $t('no_search') }}</h3>
    </div>
  </div>
</template>
<script>
  import Main from '../../filter_bar/components/Main.vue';
  import ListingFormat from '../../shared/listing/ListingFormat.vue';
  import ProgressBar from '../../shared/progress_bar/ProgressBar.vue';
  import {formatDate} from '../../shared/typescripts/dates.ts'

  export default {
    props: ['locale', 'logbooks', 'filter_params', 'filter_path', 'new_logbook_path', 
    'allow_logbook_creation', 'allow_approval', 'show_add_new_logbook'],
    components: {
        'filter-bar': Main,
        'progress-bar': ProgressBar,
    },
    data() {
      return {
        logbooksList: [],
        error: false,
      }
    },
    computed: {
      isDisabled: function() {
        return this.bulkUpdateLogbooks.length == 0;
      },
      noDataError: function() {
        let params;
        try {
          params = JSON.parse(this.filter_params)
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
        this.error = true;  
        }    
      }
    },
    mounted() {
      try {
        this.logbooksList = JSON.parse(this.logbooks) || [];
      }
      catch(err) {
        this.error = true
      }
    },
    methods: {
      //TODO: Revisit to standardize
      // Used for turning our system dates into a standard human readable format
      formatDate(dateString) {
        return formatDate(dateString)
      },

      setPath(logbook) {
        return logbook.program_standard.skills_tracking ? `logbooks/${logbook.id}/skill_sets` : `logbooks/${logbook.id}/logbook_hours`;
      },
    }
  }
</script>
